import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { quoteTransportFormDefault } from "@factory/form/form.default";
import { QuoteTransportFormRule, QuoteTransportFormSchema } from "@factory/form/form.rule";
import { useQyCreateQuoteTransport } from "@factory/query/quote-transport.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewQuoteTransport() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateQuoteTransport } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New QuoteTransport is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addQuoteTransport, isLoading: isCreating } =
    useQyCreateQuoteTransport(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<QuoteTransportFormSchema>({
    defaultValues: quoteTransportFormDefault,
    resolver: zodResolver(QuoteTransportFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: QuoteTransportFormSchema) => {
    const formData = mapCreateQuoteTransport(form);
    addQuoteTransport(formData);
  };
  const handleValidateError = (err: FieldErrors<QuoteTransportFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
